/** Human-readable line for notifications / UI (e.g. cable, lists). */
export const formatVehicleLabel = (vehicle) =>
  [vehicle?.year, vehicle?.make, vehicle?.model].filter(Boolean).join(' ') || 'Vehicle';
